var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.664,
    height: 14,
    viewBox: "0 0 12.664 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "package",
    transform: "translate(-104.945 109.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2699",
    "data-name": "Group 2699",
    transform: "translate(104.945 -109.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M12.982,7.789a.544.544,0,0,1-.272-.073L6.923,4.38a.546.546,0,0,1,.546-.947l5.786,3.336a.546.546,0,0,1-.273,1.02Z",
    transform: "translate(-3.757 -1.941)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M8.482,15.1a1.835,1.835,0,0,1-.916-.245l-4.5-2.57A1.838,1.838,0,0,1,2.15,10.7V5.554a1.838,1.838,0,0,1,.916-1.585L7.568,1.4a1.832,1.832,0,0,1,1.83,0l4.5,2.57a1.838,1.838,0,0,1,.918,1.586V10.7a1.838,1.838,0,0,1-.916,1.585L9.4,14.855A1.832,1.832,0,0,1,8.482,15.1Zm0-12.854a.74.74,0,0,0-.37.1L3.61,4.917a.74.74,0,0,0-.368.638V10.7a.741.741,0,0,0,.37.639l4.5,2.57a.739.739,0,0,0,.741,0l4.5-2.573a.74.74,0,0,0,.368-.638V5.554a.741.741,0,0,0-.37-.639l-4.5-2.57A.743.743,0,0,0,8.482,2.245Z",
    transform: "translate(-2.15 -1.152)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M8.578,10.449a.546.546,0,0,1-.274-.073L2.693,7.129a.546.546,0,1,1,.547-.946L8.578,9.272l5.338-3.088a.546.546,0,1,1,.547.946L8.852,10.376A.546.546,0,0,1,8.578,10.449Z",
    transform: "translate(-2.246 -2.923)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M11.7,18.723a.546.546,0,0,1-.546-.546V11.7a.546.546,0,1,1,1.093,0v6.48A.546.546,0,0,1,11.7,18.723Z",
    transform: "translate(-5.364 -4.723)",
    fill: "#a5a5a5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.053d1b7cb4469caf2b520c6977432f22.svg";
export { ForwardRef as ReactComponent };